export const buttonVariants = [
    'filled',
    'ghost',
    'black-on-white',
    'white-on-black',
    'black-on-white-no-border',
    'white-on-black-no-border',
    'black-on-transparent',
    'white-on-transparent',
    'black-on-gray',
    'filled-neutral',
];
export const extractButtonColorsByVariant = ({ theme, variant, customVariants, }) => {
    if (customVariants && variant in customVariants) {
        return customVariants[variant];
    }
    const disabledColors = {
        backgroundColor: theme.color.button.disabled.fill.on.background,
        borderColor: theme.color.button.disabled.border.on.background,
        color: theme.color.button.disabled.content.on.background,
    };
    switch (variant) {
        case 'filled':
        case 'white-on-black-no-border':
            return {
                normal: {
                    backgroundColor: theme.color.text.primary.on.background,
                    borderColor: theme.color.text.primary.on.background,
                    color: theme.color.fill.background,
                },
                hover: {
                    backgroundColor: theme.color.text.secondary.on.background,
                    borderColor: theme.color.text.secondary.on.background,
                    color: theme.color.fill.background,
                },
                disabled: disabledColors,
            };
        case 'ghost':
        case 'black-on-white':
            return {
                normal: {
                    backgroundColor: theme.color.fill.background,
                    borderColor: theme.color.text.primary.on.background,
                    color: theme.color.text.primary.on.background,
                },
                hover: {
                    backgroundColor: theme.color.fill.subtle,
                    borderColor: theme.color.text.secondary.on.subtle,
                    color: theme.color.text.highContrast.on.subtle,
                },
                disabled: disabledColors,
            };
        case 'white-on-black':
            return {
                normal: {
                    backgroundColor: theme.color.text.primary.on.background,
                    borderColor: theme.color.fill.background,
                    color: theme.color.fill.background,
                },
                hover: {
                    backgroundColor: theme.color.text.secondary.on.subtle,
                    borderColor: theme.color.fill.subtle,
                    color: theme.color.fill.background,
                },
                disabled: disabledColors,
            };
        case 'black-on-white-no-border':
            return {
                normal: {
                    backgroundColor: theme.color.fill.background,
                    borderColor: theme.color.fill.background,
                    color: theme.color.text.primary.on.background,
                },
                hover: {
                    backgroundColor: theme.color.fill.subtle,
                    borderColor: theme.color.fill.subtle,
                    color: theme.color.text.highContrast.on.subtle,
                },
                disabled: disabledColors,
            };
        case 'black-on-transparent':
            return {
                normal: {
                    backgroundColor: 'transparent',
                    borderColor: theme.color.text.primary.on.background,
                    color: theme.color.text.primary.on.background,
                },
                hover: {
                    backgroundColor: 'rgba(128, 128, 128, 0.1)',
                    borderColor: theme.color.text.secondary.on.background,
                    color: theme.color.text.highContrast.on.background,
                },
                disabled: disabledColors,
            };
        case 'white-on-transparent':
            return {
                normal: {
                    backgroundColor: 'transparent',
                    borderColor: theme.color.fill.background,
                    color: theme.color.fill.background,
                },
                hover: {
                    backgroundColor: 'rgba(128, 128, 128, 0.4)',
                    borderColor: theme.color.fill.subtle,
                    color: theme.color.fill.background,
                },
                disabled: disabledColors,
            };
        case 'black-on-gray':
            return {
                normal: {
                    backgroundColor: theme.color.deprecated.stoneLighter,
                    borderColor: theme.color.deprecated.stoneLighter,
                    color: theme.color.text.primary.on.subtle,
                },
                hover: {
                    backgroundColor: theme.color.fill.disabled.subtle,
                    borderColor: theme.color.fill.subtle,
                    color: theme.color.text.primary.on.subtle,
                },
                disabled: disabledColors,
            };
        case 'filled-neutral':
            return {
                normal: {
                    backgroundColor: theme.color.text.primary.on.background,
                    borderColor: theme.color.text.primary.on.background,
                    color: theme.color.fill.background,
                },
                hover: {
                    backgroundColor: theme.color.text.primary.on.background,
                    borderColor: theme.color.text.primary.on.background,
                    color: theme.color.fill.background,
                },
                disabled: disabledColors,
            };
    }
};
export function isButtonVariant(value) {
    if (!value)
        return false;
    const buttonVariants = {
        'filled': true,
        'ghost': true,
        'black-on-white': true,
        'white-on-black': true,
        'black-on-white-no-border': true,
        'white-on-black-no-border': true,
        'black-on-transparent': true,
        'white-on-transparent': true,
        'black-on-gray': true,
        'filled-neutral': true,
    };
    return buttonVariants[value] === true;
}
//# sourceMappingURL=utils.js.map